import React from 'react';
import type { BaseOutcomeIslandProps } from '../types';
import BaseSimpleIsland from '../../BaseSimpleIsland';
import OnIslandOutcomeNode from '../OnIslandOutcomeNode';


interface SimpleOutcomeIslandProps extends BaseOutcomeIslandProps { }

export default function SimpleOutcomeIsland({ outcomeActions }: SimpleOutcomeIslandProps) {
  return (
    <BaseSimpleIsland
      data-dd-privacy="allow"
      Node={OnIslandOutcomeNode}
      actions={outcomeActions}
    />
  );
}
